import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from '../../utils/hooks';
import Tabs from '../../Components/common/Tabs/Tabs';
import { Profile, MyCV, Alerts, Security } from '../../Components/pages/myProfile';
import classes from './myProfile.module.scss';
import { fetchUserData } from '../../actions/user';

function MyProfile() {
  const userId = localStorage.getItem('UserId');

  const query = useQuery();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const tabs = [
    { title: t('dashboard.profile.myprofile'), value: 'profile', component: <Profile /> },
    { title: t('dashboard.profile.mycv'), value: 'cv', component: <MyCV /> },
    { title: 'Alerts', value: 'alerts', component: <Alerts /> }
    // "Uncomment after release
    // { title: 'Security', value: 'security', component: <Security /> },
  ];
  const initTab = tabs.find((tab) => tab.value === query.get('tab'));
  const initIndex = tabs.indexOf(initTab, 0);

  /* eslint no-bitwise: ["error", { "allow": ["~"] }] */
  const [currentTab, setCurrentTab] = useState(~initIndex ? tabs[initIndex] : tabs[0]);

  useEffect(() => {
    dispatch(fetchUserData(userId));
  }, []);

  return (
    <section className={classes.container}>
      <Tabs tabs={tabs} currentTab={currentTab} setTab={setCurrentTab}>
        {tabs.find((tab) => tab.value === currentTab.value).component}
      </Tabs>
    </section>
  );
}

export default MyProfile;
